import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullyRoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/FullyRoundedButton';
import { FDHeadlineText, FDTitleText } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  rootCentered: {
    alignItems: 'center',
  },
  headerActions: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'end',
  },
  action: {
    marginRight: theme.spacing(1),
  },
});

const OnboardingPlannerViewSectionHeader = ({
  className,
  classes,
  title,
  onAddTask,
  onAddNote,
  additionalActions,
  size,
}) => {
  return (
    <Box
      className={classNames(classes.root, className, {
      })}
    >
      {size === 'sm' ? <FDTitleText value={title} color="textSecondary" /> : <FDHeadlineText value={title} size="sm" color="textSecondary" />}
      <div className={classes.headerActions}>
        {onAddTask && (
          <FullyRoundedButton
            size={'sm'}
            onClick={onAddTask}
            className={classes.action}
          >
              Add Task
          </FullyRoundedButton>
        )}
        {onAddNote && (
          <FullyRoundedButton
            size={'sm'}
            onClick={onAddNote}
            className={classes.action}
          >
              Add Note
          </FullyRoundedButton>
        )}
        {additionalActions ?? null}
      </div>
    </Box>
  );
};

OnboardingPlannerViewSectionHeader.defaultProps = {
  className: '',
  onAddTask: null,
  onAddNote: null,
  size: 'lg',
};

OnboardingPlannerViewSectionHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onAddTask: PropTypes.func,
  onAddNote: PropTypes.func,
  additionalActions: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'lg']),
};

export default withStyles(styles)(OnboardingPlannerViewSectionHeader);
